module.exports = __webpack_public_path__ + "static/media/employeebg.de539ae0.png";